




























































import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { maskMoney } from '@/utils/common'
import { IRequestMessage, RequestMessage } from '@/types/_'
import EventBus from '@/plugins/EventBus'

@Component
export default class ViewBackofficeTabelasReferencia extends Vue {
  getRequestMessage: IRequestMessage = new RequestMessage()
  loadNotasFiscais: boolean = false
  search: string = ''

  formatMoneyUtil(money: string) {
    return maskMoney(money)
  }

  get pagination() {
    return this.getFinanceiroStore.pagination
  }

  get pages() {
    if (this.pagination.rowsPerPage === null || this.pagination.totalItems === null) return 0
    return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get headers() {
    return this.getFinanceiroStore.tabelasDeReferenciaTableHeader
  }

  get tabelaReferenciaItems() {
    return this.getFinanceiroStore.tabelasDeReferencia
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 9
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getFinanceiroStore.getTabelasDeReferencia()
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }
}
